// vehicleData.js

export const BRANDS = [
  { id: "audi", label: "Audi" },
  { id: "bmw", label: "BMW" },
  { id: "mercedes", label: "Mercedes-Benz" },
  { id: "volkswagen", label: "Volkswagen" },
  { id: "porsche", label: "Porsche" },
  { id: "opel", label: "Opel" },
  { id: "ford", label: "Ford" },
  { id: "skoda", label: "Škoda" },
  { id: "seat", label: "SEAT" },
  { id: "kia", label: "Kia" },
  { id: "hyundai", label: "Hyundai" },
  { id: "renault", label: "Renault" },
  { id: "peugeot", label: "Peugeot" },
  { id: "citroen", label: "Citroën" },
  { id: "fiat", label: "Fiat" },
  { id: "nissan", label: "Nissan" },
  { id: "toyota", label: "Toyota" },
  { id: "mazda", label: "Mazda" },
  { id: "volvo", label: "Volvo" },
  { id: "jeep", label: "Jeep" },
  { id: "subaru", label: "Subaru" },
  { id: "mitsubishi", label: "Mitsubishi" },
  { id: "honda", label: "Honda" },
  { id: "suzuki", label: "Suzuki" },
  { id: "dacia", label: "Dacia" },
  { id: "mini", label: "MINI" },
  { id: "smart", label: "Smart" },
  { id: "other", label: "Andere" },
];

export const MODELS_BY_BRAND = {
  audi: ["A1", "A3", "A4", "A5", "A6", "A7", "A8", "Q2", "Q3", "Q5", "Q7", "Q8", "TT", "e-tron"],
  bmw: [
    "1er", "2er", "3er", "4er",
    "5er", "6er", "7er", "8er",
    "X1", "X2", "X3", "X4", "X5", "X6", "X7",
    "Z4", "i3", "i4", "iX"
  ],
  mercedes: ["A-Klasse", "B-Klasse", "C-Klasse", "E-Klasse", "S-Klasse", "G-Klasse", "GLA", "GLB", "GLC", "GLE", "GLS", "CLA", "CLS", "EQC", "EQA", "EQB", "EQE", "EQS"],
  volkswagen: ["Polo", "Golf", "T-Roc", "T-Cross", "Taigo", "Tiguan", "Touareg", "Passat", "Arteon", "ID.3", "ID.4", "ID.5", "ID.7"],
  porsche: ["911", "718", "Cayman", "Boxster", "Macan", "Cayenne", "Panamera", "Taycan"],
  opel: ["Corsa", "Astra", "Insignia", "Mokka", "Crossland", "Grandland", "Zafira"],
  ford: ["Fiesta", "Focus", "Kuga", "Puma", "EcoSport", "Mondeo", "Edge", "Mustang", "Tourneo", "Transit", "Explorer", "Explorer EV"],
  skoda: ["Fabia", "Scala", "Octavia", "Superb", "Karoq", "Kodiaq", "Kamiq", "Enyaq"],
  seat: ["Ibiza", "Arona", "Leon", "Ateca", "Tarraco"],
  kia: ["Rio", "Picanto", "Ceed", "Stonic", "Sportage", "Sorento", "Niro", "EV6"],
  hyundai: ["i10", "i20", "i30", "Kona", "Tucson", "Santa Fe", "Ioniq 5", "Ioniq 6"],
  renault: ["Clio", "Megane", "Captur", "Kadjar", "Koleos", "Twingo", "Zoe"],
  peugeot: ["208", "308", "3008", "5008", "2008", "508", "Rifter"],
  citroen: ["C3", "C4", "C5", "C5 Aircross", "C4 Cactus", "Berlingo"],
  fiat: ["500", "Panda", "Tipo", "Punto", "Panda", "500X", "500L"],
  nissan: ["Micra", "Juke", "Qashqai", "X-Trail", "Leaf", "Ariya"],
  toyota: ["Yaris", "Corolla", "C-HR", "RAV4", "Auris", "Camry", "Prius", "GR Yaris"],
  mazda: ["2", "3", "CX-3", "CX-30", "CX-5", "MX-5"],
  volvo: ["V40", "V60", "V90", "XC40", "XC60", "XC90", "S60", "S90"],
  jeep: ["Renegade", "Compass", "Cherokee", "Wrangler"],
  subaru: ["Impreza", "Forester", "Outback", "XV"],
  mitsubishi: ["ASX", "Lancer", "Outlander", "Eclipse"],
  honda: ["Civic", "Accord", "Jazz", "CR-V"],
  suzuki: ["Swift", "Vitara", "Ignis", "SX4"],
  dacia: ["Sandero", "Duster", "Jogger", "Logan"],
  mini: ["Cooper", "Clubman", "Countryman", "Convertible", "Electric"],
  smart: ["Fortwo", "Forfour", "EQ Fortwo"],
};
